import { Alert, PageHeader } from "@station/ui";
import { createFileRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { SupportAccessBody } from "../../../features/platform/account.js";
import { useDocumentTitle } from "../../../lib/hooks.js";
import { usePermissions } from "../../../lib/session.js";

export const Route = createFileRoute("/_app/ayarlar/destek-erisimi")({ component: SupportAccessPage });

/**
 * Destek erişimi (Prompt 24): platform ekibinin istekleri; onay / ret, etkin erişimi geri alma ve her isteğin kaydı. Erişim
 * süreli ve salt okunurdur; onaylanmamış istekle hiçbir veri görülemez.
 */
function SupportAccessPage(): ReactElement {
  const { t } = useTranslation();
  const allowed = usePermissions().has("tenant.support.manage");
  useDocumentTitle(t("menu.supportAccess"));
  return (
    <>
      <PageHeader
        title={t("menu.supportAccess")}
        description={t("account.support.description")}
        breadcrumb={[{ label: t("menu.groups.settings") }, { label: t("menu.supportAccess") }]}
      />
      {allowed ? <SupportAccessBody /> : <Alert tone="info">{t("account.noPermission")}</Alert>}
    </>
  );
}
